import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Subject from "../components/Subject";

const StarredPage = () => {
  return (
    <>

      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        <Breadcrumb title="Subject" />

        {/* StarredLayer */}
        <Subject />

      {/* </MasterLayout> */}

    </>
  );
};

export default StarredPage; 
